export function popFrontURL(url, popNumber) {
    if (url) return url.split("/").slice(popNumber).join("/") + "/";
    else return "";
}
